import Link from 'next/link'
import { ArticleCard } from './ArticleCard'
import { Container } from '@/components/shared/Container'
import styled from 'styled-components'

type ArticlesByCategoryProps = {
  categoryID: number
  categoryName: string
  categorySlug: string
  subCategorySlug?: string
  showHeader?: boolean
  articles?: {
    id?: number
    _firstPublishedAt?: string
    articleSlug?: string
    articleTitle?: string
    abstract: string
    featuredImage: {
      responsiveImage?: {
        alt?: string
        aspectRatio?: number
        base64?: string
        bgColor?: string
        height?: number
        sizes?: string
        src?: string
        srcSet?: string
        title?: string
        webpSrcSet?: string
        width?: number
      }[]
    }
    square: {
      responsiveImage?: {
        alt?: string
        aspectRatio?: number
        base64?: string
        bgColor?: string
        height?: number
        sizes?: string
        src?: string
        srcSet?: string
        title?: string
        webpSrcSet?: string
        width?: number
      }[]
    }
  }[]
}

const StyledCategoryHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: 16px;
  margin-bottom: 32px;
  border-bottom: 1px solid ${(props) => props.theme.v2.onSurface.subdued.border};
  h2 {
    margin: 0;
    font-size: 40px;
    line-height: 54px;
    color: ${(props) => props.theme.v2.onSurface.text};
    font-family: ${(props) => props.theme.v2.font.nantes};
  }

  a {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    padding-bottom: 4px;
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    h2 {
      font-size: 32px;
      line-height: 48px;
    }
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    h2 {
      font-size: 24px;
      line-height: 32px;
    }
    a {
      font-size: 14px;
      padding-bottom: 0;
    }
  }
`

const StyledArticleGrid = styled.div`
  display: grid;
  grid-auto-columns: 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  gap: 48px 32px;
  margin-bottom: 48px;
  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    grid-template-columns: 1fr 1fr;
    gap: 24px 24px;
  }
`

const StyledSpacer = styled.div`
  margin-top: 64px;
`

export const ArticlesByCategory = ({
  categoryID,
  categoryName,
  categorySlug,
  subCategorySlug,
  articles,
  showHeader,
}: ArticlesByCategoryProps) => {
  if (articles && articles.length > 0) {
    let categoryLink = categorySlug
    subCategorySlug && (categoryLink = categoryLink + '/' + subCategorySlug)

    return (
      <Container>
        {showHeader ? (
          <StyledCategoryHeader>
            <Link href={`/learn/category/${categoryLink}`} passHref>
              <h2 key={categoryID}>{categoryName}</h2>
            </Link>
            <Link href={`/learn/category/${categoryLink}`}>View all</Link>
          </StyledCategoryHeader>
        ) : (
          <StyledSpacer />
        )}
        <StyledArticleGrid>
          {articles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </StyledArticleGrid>
      </Container>
    )
  }
  return null
}
